import { ReactElement, useCallback, memo } from 'react';
import { Menu } from '@mui/material';

import { OrdersFilterMenuGiverProps } from './types';
import OrdersFilterMenuGiverProvider from './Context';
import OrdersFilterMenuGiverVariant from './Variant';
import OrdersFilterMenuGiverActions from './Actions';
import { OrdersFilterMenuGiverContainer } from './styles';

const OrdersFilterMenuGiver = ({
  anchorEl,
  anchorOrigin = { horizontal: 'center', vertical: 'bottom' },
  transformOrigin = { horizontal: 'center', vertical: 'top' },
  open,
  onClose,
  type,
  currentFilters,
}: OrdersFilterMenuGiverProps): ReactElement => {
  const handleManualClose = useCallback(() => {
    onClose?.({}, 'backdropClick');
  }, [onClose]);

  const handleClose = useCallback(() => {
    handleManualClose();

    currentFilters.onResetFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose, currentFilters.onResetFilters]);

  return (
    <Menu
      id="orders-filters-menu-giver"
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={open}
      onClose={handleClose}
      keepMounted
    >
      <OrdersFilterMenuGiverProvider
        value={{ type, currentFilters, handleManualClose }}
      >
        <OrdersFilterMenuGiverContainer>
          <OrdersFilterMenuGiverVariant />

          <OrdersFilterMenuGiverActions />
        </OrdersFilterMenuGiverContainer>
      </OrdersFilterMenuGiverProvider>
    </Menu>
  );
};

export default memo(OrdersFilterMenuGiver);
